// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2izPh","label":"CategoryService_label__1wXHN","location":"CategoryService_location__3j4jb"};